import { translateLabel } from "@/i18n/messages";
export const RIDE_MODE = {
  USUAL: "usual",
  SOLO: "solo",
  FRIENDS: "friends",
  FAMILY_KIDS: "family-kids",
};

export const RIDE_MODE_OPTIONS = [
  { value: RIDE_MODE.USUAL, label: "My usual" },
  { value: RIDE_MODE.SOLO, label: "Solo" },
  { value: RIDE_MODE.FRIENDS, label: "Friends" },
  { value: RIDE_MODE.FAMILY_KIDS, label: "Family-Kids" },
];

const MODE_CONTEXT = {
  [RIDE_MODE.SOLO]: "Solo",
  [RIDE_MODE.FRIENDS]: "Friends",
  [RIDE_MODE.FAMILY_KIDS]: "Family-Kids",
};

export const normalizeRideMode = (value) => (
  RIDE_MODE_OPTIONS.some((option) => option.value === value) ? value : RIDE_MODE.USUAL
);

export const rideModeReducer = (state, event) => {
  switch (event?.type) {
    case "SET":
      return normalizeRideMode(event.value);
    case "CLEAR":
      return RIDE_MODE.USUAL;
    default:
      return state;
  }
};

export const rideModeLabel = (value) => translateLabel(
  RIDE_MODE_OPTIONS.find((option) => option.value === normalizeRideMode(value))?.label ?? "My usual"
);

export const effectiveRiderContext = (profile, rideMode) => {
  const normalized = normalizeRideMode(rideMode);
  if (normalized !== RIDE_MODE.USUAL) {
    return {
      source: "ride-mode",
      ridingContexts: [MODE_CONTEXT[normalized]],
    };
  }

  const profileContexts = profile?.riding_contexts ?? [];
  return {
    source: profileContexts.length ? "profile" : "general",
    ridingContexts: profileContexts.length ? profileContexts : null,
  };
};
